import { render, staticRenderFns } from "./customer-vehicle.vue?vue&type=template&id=2fb36c0a&scoped=true&"
import script from "./customer-vehicle.vue?vue&type=script&lang=js&"
export * from "./customer-vehicle.vue?vue&type=script&lang=js&"
import style0 from "./customer-vehicle.vue?vue&type=style&index=0&id=2fb36c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb36c0a",
  null
  
)

export default component.exports